import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CoreDirectivesModule} from "../../../../../../../@core/directives/directives";
import {TranslocoModule} from "@jsverse/transloco";
import {PlaybookGuidelineStatusEnum} from '../plyabbok-guideline-run-tile/playbook-guideline-run-tile.component';
import {CommonModule} from "@angular/common";


@Component({
  selector: 'app-guideline-list-status-filter',
  standalone: true,
    imports: [
        CommonModule,
        CoreDirectivesModule,
        TranslocoModule
    ],
  templateUrl: './guideline-list-status-filter.component.html',
  styleUrl: './guideline-list-status-filter.component.scss'
})
export class GuidelineListStatusFilterComponent {
    protected PlaybookGuidelineStatusEnum = PlaybookGuidelineStatusEnum;

    @Input({required: true}) guideLines : [];
    @Input({required: true}) status:PlaybookGuidelineStatusEnum[];

    @Output() statusChanged: EventEmitter<PlaybookGuidelineStatusEnum[]> = new EventEmitter();

    filterByStatus(status:PlaybookGuidelineStatusEnum){
        const statusesToUpdate = Array.isArray(this.status) ? [...this.status] : null;
        this.statusChanged.emit(this.upsertStatuses(status, statusesToUpdate  ));
    }

    private upsertStatuses(status: PlaybookGuidelineStatusEnum, statuses: PlaybookGuidelineStatusEnum[]):PlaybookGuidelineStatusEnum[]{
        if(Array.isArray(statuses) ){
            const index = statuses.indexOf(status);
            if(index === -1){
                statuses.push(status);
            }else{
                statuses.splice(index,1);
            }
        }

        if(!statuses && status != null ){
            return  [status];
        }

        return  statuses;
    }
}
